<template>
    <transition name="fade">
        <div class="fixed-wrap" v-show="flag">
            <z-scrollDiv class="downDocument" :class="{active:move_flag}">
                <div class="back" @click="back">
                    <img src="~src/assets/image/fillBack.png">
                </div>
                
                <div class="doc-select">
                    <div class="append">文档模板</div>
                    <el-select @change="seleteDoc" v-model="tempId" filterable placeholder="请选择">
                        <el-option v-for="item in taskTpl" :key="item.id" :label="item.tpl_name" :value="item.id">
                        </el-option>
                    </el-select>
                </div>

                <!-- 列表 -->
                <div class="doc_list">
                    <div class="head">
                        <el-checkbox v-model="check_all" @change="checkAll" :disabled="dataList.length == 0"></el-checkbox>
                        <div>创建时间</div>
                        <div>创建者</div>
                        <div>文档名称</div>
                        <div class="front-btn green" @click="downLoad()">下载</div>
                    </div>
                    <el-checkbox-group v-model="doc_idOptions" class="wrap">
                        <div class="item" v-for="item in dataList" :key="item.id">
                            <el-checkbox :label="item.id">{{ "" }}</el-checkbox>
                            <div>{{item.created_at}}</div>
                            <div>{{item.tpl_doc_type==1?"管理员":item.real_name}}</div>
                            <div class="overhide"><span class="blue" @click="downLoad(item.id)" :title="item.tpl_doc_name">{{ item.tpl_doc_name }}</span></div>
                        </div>
                        <z-noData :list="dataList"></z-noData>
                    </el-checkbox-group>
                </div>

            </z-scrollDiv>
        </div>
    </transition>
</template>

<script>
    import { mapState } from "vuex"
    
    export default {
        props:["flag"],
        data() {
            return {
                data: {},
                move_flag:false,  //滑动判断
                tempId:"",  //选中模板的id

                check_all:false,  //全选判断
                doc_idOptions:[],  //已选id
            }
        },

        computed: {
            ...mapState(["taskTpl"]),
            dataList(){  //列表数据
                return this.data.list || [];
            },
            id_list(){
                return this.dataList.map(item=>item.id);
            },
            ids_str(){
                return this.doc_idOptions.join(",");
            },
        },

        watch: {
            doc_idOptions(arr){  //子选项变化
                let maxLen = this.id_list.length;
                if( maxLen == 0){
                    this.check_all = false;
                    return;
                }
                this.check_all = arr.length == maxLen;
            },
            flag(val){
                if(val){
                    this.tempId = this.taskTpl[0].id;
                    setTimeout(()=>{
                        this.move_flag = true;
                    });
                }
            },
        },

        created() {
            this.seleteDoc(1);
        },

        methods: {
            back() {  //返回
                this.move_flag = false;
                setTimeout(()=>{
                    this.$emit("close");
                    this.selected = false;
                    this.tempId = 1;
                    this.doc_idOptions = false;
                },200);
            },
            seleteDoc(id) {   //获取文档列表
                let url = `api/clerk/task_tpl/${id}/doc`;
                this.$http.get(url).then(res => {
                    if(res.status == 200){
                        this.data = res.res_data;
                        this.doc_idOptions = [];
                    }
                }).catch(err =>{
                    this.errorTip("出错啦");
                })
            },
            downLoad(id) {   //  下载/批量下载
                let ids_str = id || this.ids_str;
                if(ids_str == ""){
                    this.errorTip("没有选择文件")
                    return;
                }

                this.$http.get(`api/clerk/tpl_doc/download`,{
                    params:{
                        ids:ids_str
                    }
                });
            },

            // *****checkbox
            checkAll(event){
                this.doc_idOptions = event.target.checked?this.id_list:[];
            },
        },


    }
</script>

<style lang="less" rel="stylesheet/less" scoped>
    .downDocument .back {
        width: 54px;
        height: 34px;
        background: #01b6ad;
        margin-top: 19px;
        cursor: pointer;
    }

    .back img {
        margin-left: 30px;
        margin-top: 10px;
    }

    //************************************
    .fixed-wrap{
        position: fixed;
        z-index: 20;
        width:100%;
        height: 100%;
        top:0;
        left:0;
        background:rgba(0,0,0,0.5);
        .downDocument{
            position:absolute;
            top: 0;
            right:-620px;
            width: 620px;
            height: 100%;
            background: #ffffff;
            // overflow-y: scroll;
            // border-left: 1px solid #e6e6e6;
            transition:0.4s;
            &.active{
                right: 0;
            }
        }
    }

    // 头部重写
    .doc-select{
        zoom:1;
        margin: 20px 0 30px 60px;
        &:after{
            content:"";
            display:block;
            clear: both;
        }
        >div{
            float:left;
        }
        .append{
            background-color: #fbfdff;
            color: #97a8be;
            vertical-align: middle;
            display: table-cell;
            position: relative;
            border: 1px solid #bfcbd9;
            border-radius: 4px;
            padding: 0 10px;
            // width: 1px;
            white-space: nowrap;
            border-right: 0;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            height:30px;
            line-height: 28px;
            box-sizing: border-box;
        }
        
    }

    .doc_list{
        height:calc(~"100% - (34px + 19px) - (30px + 30px + 20px)");
        @head_h:50px;
        .head,.wrap .item{
            padding-left:60px;
            position: relative;
            .el-checkbox{
                position: absolute;
                top:50%;
                transform: translateY(-50%);
                left:20px;
            }

            overflow: hidden;
            >div{
                float:left;
            }

            >div:nth-of-type(1){
                width:30%;
            }
            >div:nth-of-type(2){
                width:20%;
            }
            >div:nth-of-type(3){
                width:47%;
                padding-right: 3%;
            }
        }
        .head{
            background:#d7f7f5;
            height: @head_h;
            line-height: @head_h;
            font-size:14px;
            color:#333;
            .front-btn{
                position: absolute;
                top:50%;
                transform: translateY(-50%);
                right:10px;
            }
        }
        .wrap{
            height:calc(~"100% - @{head_h}");
        }

        .wrap .item{
            height: 50px;
            line-height: 50px;
            font-size:12px;
            color:#333;
            border-bottom: 1px solid #ccc;
            .blue{
                color:#20a0ff;
                cursor: pointer;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// downDocument.vue?3262a0fc